

import React from 'react';

import '../../styles/Counter.css';

const counterData = [
{
    number: '3k',
    text:'clients'
},
{
    number: 30,
    text:'Running Projects'
},
{
    number: 900,
    text:'Completed'
},
]

const Counter = () => {
    return <section className="counter" id="Projects">
        <div className="container">
          <div className="counter_wrapper">
            {
                counterData.map((item,index)=> (
                    <div className="counter_item" key={index}>
                    <h3 className="counter_number">{item.number}+</h3>
                    <h4 className="counter_title">{item.text}</h4>
                </div>

                ))
            }
            
            </div>  
        </div>
    </section>
}

export default Counter;

